import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { common } from '@ocean/ui'

const { Scrollbars } = common

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  justify-content: space-between;
`

export const ContentScrollbars = styled(Scrollbars)`
  flex: 1 1 auto;
  height: 0;
`

export const Content = styled.div`
  ${({ theme }) => media.sm`
    padding-right: ${theme.space.desktop.small};
  `}
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: ${theme.space.desktop.base};
  `}
`

export const FooterSide = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm`
    flex: 1 0;
    margin-right: ${theme.space.desktop.base};
    margin-bottom: 0;
  `}
`

export const FooterLink = styled.span`
  ${({ theme }) => `
    font-size: ${theme.fontSize.mobile.base};
    font-weight: ${theme.fontWeight.bold};
    color: ${theme.color.white};
    text-decoration: underline;
    cursor: pointer;
  `}
`

export const FooterAction = styled.div`
  flex-shrink: 0;
`
